'use client';

import React, { FC } from 'react';
import icon from '~/assets/icons/500.svg';
import background500 from '~/assets/images/500.jpg';
import ErrorBody from '~/layouts/app-layout/components/error';

const Custom500Page: FC = () => {
  return (
    <html lang="ru">
      <body>
        <ErrorBody
          ErrorIcon={icon}
          description="У нас возникли технические проблемы.<br/>Но мы их уже устраняем!"
          title="Ошибка"
          errorBackground={background500}
          errorAlt="ошибка 500"
        />
      </body>
    </html>
  );
};

export default Custom500Page;
